/**
 * toggles accordion closed on mobile and open on desktop
 */
export var initMobileAccordions = function (accordions) {
    var media = window === null || window === void 0 ? void 0 : window.matchMedia("(min-width: 768px)" /* mediaQueries.TABLET */);
    var mediaPrint = window === null || window === void 0 ? void 0 : window.matchMedia("print");
    var toggleAccordions = function () {
        var matches = media.matches;
        accordions.forEach(function (accordion) {
            accordion.toggleAttribute('open', matches);
        });
    };
    media.addEventListener('change', function () {
        if (!mediaPrint.matches) {
            toggleAccordions();
        }
    });
    toggleAccordions();
};
/**
 * Accordion group toggle all other accordions closed when one is opened
 */
export var initAccordionGroup = function (accordionGroup) {
    var accordions = accordionGroup.querySelectorAll('details');
    var mediaPrint = window === null || window === void 0 ? void 0 : window.matchMedia("print");
    accordions.forEach(function (accordion) {
        accordion.addEventListener('click', function () {
            if (!mediaPrint.matches) {
                if (!accordion.hasAttribute('open')) {
                    accordions.forEach(function (relatedAccordion) {
                        if (accordion != relatedAccordion)
                            relatedAccordion.removeAttribute('open');
                    });
                }
            }
        });
    });
};
export var initTrackedAccordions = function (trackedAccordions) {
    trackedAccordions.forEach(function (trackedAccordion) {
        var id = trackedAccordion.getAttribute('id');
        trackedAccordion.addEventListener('toggle', function () {
            var isOpen = trackedAccordion.hasAttribute('open');
            window.sessionStorage.setItem(id, isOpen ? 'true' : 'false');
        });
    });
    Object.keys(window.sessionStorage).forEach(function (key) {
        var trackedAccordion = document.querySelector("#".concat(key));
        var value = window.sessionStorage.getItem(key);
        if (trackedAccordion) {
            trackedAccordion.toggleAttribute('open', value === 'true' ? true : false);
        }
    });
};
